module.exports = __webpack_public_path__ + "static/media/beforeEnding.edeca836.mp3";